/* Sofia's Spot — gift wrapping + cards, both at LINE-ITEM level (Aug 2026).
     • wrap → properties[Gift wrap]="Yes" on the product line
     • note → To / From / Message on the card line
   PERFORMANCE: when a card is pending, the product and the card are added in a
   SINGLE /cart/add.js call using the items[] form, and the drawer is rendered
   once. The old path fired four sequential requests (card add, theme add, the
   theme's own drawer render, then a cart re-read).
   Cart rows are enhanced by a MutationObserver on the drawer instead of three
   blind /cart.js reads per page load.
   25 Sep 2026 (cart drawer offers, cart-v1):
     • the drawer refresh now goes through the theme (Shopify.theme.ajaxCart.updateView), so x, +/- and quantity keep
       working after a gift-wrap toggle, a card add or a note edit (they went dead until the drawer was reopened);
     • note edits keep the card line's other properties (the _bundle_* stamps, Gift wrap) instead of wiping them;
     • the card sheet opens inside the drawer when its opener is in the drawer, so tapping in the sheet no longer
       closes the drawer behind it; from a product page it opens on the page as before;
     • a card chosen from the drawer carries the opener's stamp (data-sg-stamp) and is announced as sofia_bundle_add;
     • the note being typed stays open, keeps its text and keeps focus across the refresh that follows each save;
     • every cart write goes through window.sofiaCartQueue when present (Shopify drops a change when two land together).
   Audit, 25 Sep 2026 (evening):
     • ONE queue for every cart write on the page: the theme's own add to cart, +/-, remove and attribute writes now wait
       their turn behind the gift box, the drawer offers and the card (wrapThemeCart);
     • Add to Cart with a card chosen: the button is disabled while the add runs, so a double tap can't add twice;
     • if the product and its card can't go in together, the cart is read before and after, the missing piece is tried
       on its own, and if the CARD is the one that failed the shopper is told, keeps the note, and the next card chosen
       goes straight into the cart with it (addNow);
     • Enter in a To / From field moves to the next field instead of submitting the form (product page and drawer);
     • drawer notes are saved when the shopper leaves the note, before Checkout goes ahead, and on leaving the page,
       not on every pause (the pause save rebuilt the drawer mid-typing and closed the phone keyboard);
     • the card sheet is an auto popover: Esc / back / tapping outside close it cleanly and the page scrolls again;
       focus moves into it;
     • the clean-up of the retired August gift attributes (a /cart.js read on every page) is gone. */
(function () {
  if (window.__sofiaGift) return; window.__sofiaGift = true;

  var CARD_TYPE = 'Cards';
  var pending = null;
  var addNow = false;

  var Q = window.sofiaCartQueue = window.sofiaCartQueue || (function () {
    var tail = Promise.resolve();
    return function (task) { var run = tail.then(task, task); tail = run.catch(function () {}); return run; };
  })();
  function queued(task) { return (window.sofiaCartQueue || Q)(task); }
  /* The theme's own cart writes join the same queue. Its functions all return promises; nothing queued ever calls one of
     them from inside a queued task, so the queue cannot wait on itself. */
  function wrapThemeCart() {
    var C = window.Shopify && Shopify.theme && Shopify.theme.cart;
    if (!C || C.__sofiaQueued) return;
    ['addItem', 'addItemFromForm', 'updateItem', 'removeItem', 'clearItems', 'updateAttributes', 'updateNote'].forEach(function (k) {
      var f = C[k]; if (typeof f !== 'function') return;
      C[k] = function () { var a = arguments, self = this; return queued(function () { return f.apply(self, a); }); };
    });
    C.__sofiaQueued = true;
  }
  wrapThemeCart();
  document.addEventListener('DOMContentLoaded', wrapThemeCart);
  window.addEventListener('load', wrapThemeCart);

  function pub(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function getCartJSON() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }
  function qtyOf(cart, vid) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (String(it.variant_id) === String(vid)) n += it.quantity; });
    return n;
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-sg-wrap]')) return;
    var on = el.checked;
    document.querySelectorAll('[data-sg-wrap]').forEach(function (c) { c.checked = on; });
    document.querySelectorAll('[data-sg-wrapinput]').forEach(function (h) { h.disabled = !on; });
  });

  /* ---------- PDP card box ---------- */
  function boxes() { return document.querySelectorAll('[data-sg-cardbox]'); }
  function noteFromBox(box) {
    var p = {};
    box.querySelectorAll('[data-sg-p]').forEach(function (f) {
      var v = (f.value || '').trim();
      if (v) p[f.getAttribute('data-sg-p')] = v;
    });
    return p;
  }
  function paintChosen(title) {
    boxes().forEach(function (box) {
      var pick = box.querySelector('[data-sg-pick]');
      var chosen = box.querySelector('[data-sg-chosen]');
      var note = box.querySelector('[data-sg-note]');
      var name = box.querySelector('[data-sg-cardname]');
      if (pick) pick.hidden = !!title;
      if (chosen) chosen.hidden = !title;
      if (note) note.hidden = !title;
      if (name && title) name.textContent = title;
    });
  }
  function cardError(on) {
    document.querySelectorAll('[data-sg-err]').forEach(function (m) { m.hidden = !on; });
  }
  function resetBox() {
    pending = null; addNow = false; cardError(false);
    document.querySelectorAll('[data-sg-wrap]').forEach(function (c) { c.checked = false; });
    document.querySelectorAll('[data-sg-wrapinput]').forEach(function (h) { h.disabled = true; });
    boxes().forEach(function (box) {
      box.querySelectorAll('[data-sg-p]').forEach(function (f) { f.value = ''; });
    });
    paintChosen(null);
  }

  /* ---------- picker ---------- */
  var RULES = [
    ['Birthday', /birthday|another year|cake|candles/i], ['Baby', /baby|little one/i],
    ['Wedding', /wedding|happily ever after|engag/i], ['New Home', /new home|house/i],
    ['Thanks', /thank|grateful|peach|bunch/i], ['Mum', /\bmum\b|mother/i],
    ['Dad', /\bdad\b|father/i], ['Christmas', /christmas|merry|santa|peas on earth|ibis/i],
    ['Sympathy', /darkest nights|thinking of you|sympathy/i], ['Congrats', /congrat/i]
  ];
  var ORDER = ['Birthday','Everyday','Thanks','Baby','Mum','Wedding','New Home','Congrats','Sympathy','Christmas','Dad'];
  var state = { occ: null, cards: null, stamp: null, inDrawer: false };
  function occOf(t) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i][1].test(t)) return RULES[i][0];
    return 'Everyday';
  }
  function ensureSheet() {
    var s = document.getElementById('sofia-gift-sheet');
    if (s) return s;
    s = document.createElement('div');
    s.id = 'sofia-gift-sheet'; s.className = 'sg-sheet';
    s.setAttribute('role','dialog'); s.setAttribute('aria-modal','true');
    s.setAttribute('aria-label','Choose a card');
    try { s.setAttribute('popover','auto'); } catch (e) {}
    s.innerHTML = '<div class="sg-sheet__head"><div class="sg-sheet__bar"><h3 class="sg-sheet__title">Choose your card</h3>'
      + '<button type="button" class="sg-sheet__close" data-sg-close aria-label="Close">&times;</button></div>'
      + '<p class="sg-sheet__sub">We’ll handwrite your note inside</p></div>'
      + '<div class="sg-sheet__chips" data-sg-chips></div>'
      + '<div class="sg-sheet__grid" data-sg-grid><p class="sg-sheet__loading">Loading cards…</p></div>';
    document.body.appendChild(s);
    /* Esc, the back gesture, tapping outside or the drawer closing all close an auto popover: clean up after any of them. */
    s.addEventListener('toggle', function (ev) {
      if (ev.newState === 'closed') { s.classList.remove('sg-open'); s.style.display = 'none'; document.documentElement.classList.remove('sg-lock'); }
    });
    return s;
  }
  /* Opened from inside the cart drawer, the sheet has to live inside the drawer: a manual popover hanging off
     <body> sits outside the drawer's auto popover, so the first tap in the sheet light-dismissed the drawer. */
  function sheetHost(opener) {
    return (opener && opener.closest && opener.closest('#slideout-ajax-cart')) || document.body;
  }
  function setOpen(on, opener) {
    var s = ensureSheet();
    if (on) {
      s.style.display = 'flex'; var shown = false;
      var home = sheetHost(opener);
      if (typeof s.showPopover === 'function') {
        try { if (s.parentNode !== home) home.appendChild(s); s.showPopover(); shown = true; } catch (e) {}
      }
      if (!shown) {
        var host = (opener && opener.closest && opener.closest('[popover]')) || document.getElementById('slideout-ajax-cart') || document.body;
        if (s.parentNode !== host) host.appendChild(s);
        s.classList.add('sg-open');
      }
      document.documentElement.classList.add('sg-lock');
      setTimeout(function () { var c = s.querySelector('[data-sg-close]'); if (c) { try { c.focus({ preventScroll: true }); } catch (e) {} } }, 40);
    } else {
      if (typeof s.hidePopover === 'function') { try { s.hidePopover(); } catch (e) {} }
      s.classList.remove('sg-open'); s.style.display = 'none';
      document.documentElement.classList.remove('sg-lock');
    }
  }
  function loadCards() {
    if (state.cards) return Promise.resolve(state.cards);
    return fetch('/collections/greeting-cards/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        state.cards = (d.products || []).filter(function (p) {
          return p.variants && p.variants[0] && p.variants[0].available;
        }).map(function (p) {
          return { t: p.title, img: (p.images && p.images[0] && p.images[0].src) || '',
                   v: p.variants[0].id, pid: p.id, pr: parseFloat(p.variants[0].price), o: occOf(p.title) };
        });
        return state.cards;
      });
  }
  function thumb(s) { return s ? s.replace(/(\.(jpg|jpeg|png|webp))/i, '_400x$1') : ''; }
  function render() {
    var s = ensureSheet(); if (!state.cards) return;
    var cards = state.cards, counts = {};
    cards.forEach(function (c) { counts[c.o] = (counts[c.o] || 0) + 1; });
    var avail = ORDER.filter(function (o) { return counts[o]; });
    if (avail.indexOf(state.occ) === -1) state.occ = avail[0] || null;
    s.querySelector('[data-sg-chips]').innerHTML = avail.map(function (o) {
      return '<button type="button" class="sg-chip' + (state.occ === o ? ' on' : '') + '" data-sg-chip="' + o + '">' + o + ' <b>' + counts[o] + '</b></button>';
    }).join('');
    /* first eight eager so nothing looks empty, the rest lazy — the tile height
       is fixed in CSS now, so lazy images can no longer collapse the grid */
    var list = cards.filter(function (c) { return c.o === state.occ; });
    s.querySelector('[data-sg-grid]').innerHTML = list.map(function (c, i) {
      return '<button type="button" class="sg-card" data-sg-add="' + c.v + '" data-sg-pid="' + c.pid + '" data-sg-title="' + c.t.replace(/"/g,'&quot;') + '">'
        + '<span class="sg-card__ph"><img ' + (i < 8 ? '' : 'loading="lazy" ') + 'src="' + thumb(c.img) + '" alt=""></span>'
        + '<span class="sg-card__n">' + c.t + '</span><span class="sg-card__p">$' + c.pr.toFixed(2) + '</span></button>';
    }).join('');
    s.querySelector('[data-sg-grid]').scrollTop = 0;
  }

  function hideLoader() {
    document.querySelectorAll('.js-mini-cart-loader').forEach(function (el) {
      el.style.display = 'none'; el.style.opacity = '0';
    });
  }
  function cartConfig() {
    var el = document.getElementById('cart-config');
    try { return JSON.parse((el && el.textContent) || '{}'); } catch (e) { return {}; }
  }
  /* Before 25 Sep this swapped the template into the first cart container by hand, which left the theme's x, +/- and
     quantity listeners unbound. Kept only as the fallback for a page without the theme's cart API. */
  function legacyRefresh(open) {
    var root = document.querySelector('[data-sg-cart-url]') || document.body;
    var url = (root.getAttribute && root.getAttribute('data-sg-cart-url')) || '/cart';
    return fetch(url + '?view=ajax').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var tpl = doc.querySelector('template[data-html="content"]');
      var target = document.querySelector('.js-ajax-cart-content');
      if (tpl && target) {
        target.innerHTML = tpl.innerHTML;
        var opts = doc.querySelector('template[data-options]');
        if (opts) { try {
          var n = JSON.parse(opts.textContent).item_count;
          document.querySelectorAll('.js-cart-count').forEach(function (el) { el.textContent = n; });
        } catch (e) {} }
        if (open) {
          var d = document.getElementById('slideout-ajax-cart');
          if (d && typeof d.showPopover === 'function') { try { d.showPopover(); } catch (e) {} }
        }
        hideLoader(); setTimeout(hideLoader, 950);
      }
    });
  }
  /* The theme's own refresh: every cart container, the theme's listeners and the wallet buttons. Never rejects. */
  function refreshDrawer(open) {
    var T = window.Shopify && Shopify.theme;
    if (!(T && T.cart && T.cart.getCart && T.ajaxCart && T.ajaxCart.updateView)) return legacyRefresh(open).catch(function () {});
    return queued(function () { return T.cart.getCart(); }).then(function (cart) {
      var c = cartConfig();
      T.ajaxCart.updateView(c, cart);
      if (open) {
        var d = document.getElementById('slideout-ajax-cart'), isOpen = false;
        try { isOpen = !!d && d.matches(':popover-open'); } catch (e) {}
        if (!isOpen && T.ajaxCart.showDrawer) T.ajaxCart.showDrawer(c);
      }
      hideLoader(); setTimeout(hideLoader, 950);
    }).catch(function () { return legacyRefresh(open).catch(function () {}); });
  }

  /* ---------- Add to Cart: product + card in ONE request ---------- */
  function busy(btn, on) {
    if (on) { btn.__sgWas = btn.disabled; btn.__sgBusy = true; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { btn.__sgBusy = false; btn.disabled = !!btn.__sgWas; btn.removeAttribute('aria-busy'); }
  }
  /* Let the theme add the product itself (it shows its own stock message if that fails). */
  function themeAdd(atc) {
    busy(atc, false);
    atc.__sgGo = true; atc.click();
    setTimeout(function () { atc.__sgGo = false; }, 2000);
  }
  function addCardNow(v, note) {
    var card = { id: parseInt(v, 10), quantity: 1 };
    if (Object.keys(note).length) card.properties = note;
    return queued(function () { return postAdd([card]).then(function (r) { if (!r.ok) throw new Error('card'); }); })
      .then(function () { resetBox(); return refreshDrawer(true); },
            function () { pending = null; addNow = true; cardError(true); paintChosen(null); });
  }
  /* The product and the card could not go in together (one sold out, or more than we hold). Compare the cart before and
     after: Shopify may have added part of it. Nothing the shopper chose or wrote is lost silently. */
  function recover(res, atc, prod, card) {
    return queued(function () { return getCartJSON(); }).then(function (after) {
      var before = res.before || { items: [] };
      var prodIn = !prod || qtyOf(after, prod.id) > qtyOf(before, prod.id);
      var cardIn = qtyOf(after, card.id) > qtyOf(before, card.id);
      if (prodIn && cardIn) { resetBox(); return refreshDrawer(true); }
      /* nothing went in (Shopify refuses the whole request when one piece is sold out): try the product on its own to
         learn which piece failed. If the product goes in, the card was the problem and is handled below; if not, the
         theme adds it the usual way and shows its own stock message, and the card stays chosen. */
      if (!prodIn && !cardIn && prod) {
        return queued(function () { return postAdd([prod]); }).then(function (r) {
          if (!r.ok) { themeAdd(atc); return; }
          return addCardNow(card.id, card.properties || {}).then(function () { if (addNow) return refreshDrawer(false); });
        }, function () { themeAdd(atc); });
      }
      if (!prodIn) {
        if (cardIn) resetBox();
        themeAdd(atc);
        return;
      }
      /* the product is in, the card is not: try the card on its own, then tell the shopper */
      /* the drawer stays shut so the message on the card row is seen; the cart count still updates */
      return addCardNow(card.id, card.properties || {}).then(function () { if (addNow) return refreshDrawer(false); });
    }).catch(function () { themeAdd(atc); });
  }
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.AddtoCart');
    if (!atc || !pending || atc.__sgGo) return;
    e.preventDefault(); e.stopPropagation();
    if (atc.__sgBusy) return;

    var form = atc.closest('form');
    var vidEl = form && form.querySelector('.formVariantId');
    var qtyEl = form && form.querySelector('.formQty');
    var wrapEl = form && form.querySelector('[data-sg-wrapinput]');
    var box = document.querySelector('[data-sg-cardbox]');
    var note = box ? noteFromBox(box) : {};

    var prod = null;
    if (vidEl && vidEl.value) {
      prod = { id: parseInt(vidEl.value, 10), quantity: parseInt((qtyEl && qtyEl.value) || 1, 10) || 1 };
      if (wrapEl && !wrapEl.disabled) prod.properties = { 'Gift wrap': 'Yes' };
    }
    var card = { id: parseInt(pending.v, 10), quantity: 1 };
    if (Object.keys(note).length) card.properties = note;
    var items = prod ? [prod, card] : [card];

    busy(atc, true);
    queued(function () {
      return getCartJSON().catch(function () { return null; }).then(function (before) {
        return postAdd(items).then(function (r) { return { ok: r.ok, before: before }; });
      });
    }).then(function (res) {
      if (res.ok) { busy(atc, false); resetBox(); return refreshDrawer(true); }
      return recover(res, atc, prod, card);
    }, function () { return recover({}, atc, prod, card); })
      .then(function () { if (atc.__sgBusy) busy(atc, false); }, function () { if (atc.__sgBusy) busy(atc, false); });
  }, true);

  /* ---------- per-line gift controls in the cart ---------- */
  function setLine(key, qty, props) {
    return queued(function () {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, properties: props })
      });
    }).then(function () { return refreshDrawer(false); })
      .catch(function () {});
  }
  function esc(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  /* The card note being typed. Each save changes the line (and its key) and refreshes the drawer, which rebuilds the
     row; the draft puts the typed text, the open fields and the focus back so the shopper can keep writing. */
  var draft = null;

  function enhanceLines() {
    var rows = document.querySelectorAll('.ajax-cart__cart-item');
    if (!rows.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        (cart.items || []).forEach(function (it) { byKey[it.key] = it; });
        /* a note still being written is put back if the drawer is rebuilt for any other reason */
        if (draft && !draft.dirty && Date.now() - draft.t > 6000) draft = null;
        var refocus = null;
        rows.forEach(function (row) {
          var kEl = row.querySelector('[data-item-key]');
          var key = kEl && kEl.getAttribute('data-item-key');
          var item = key && byKey[key];
          if (!item) return;
          var host = row.querySelector('.ajax-cart__item-details');
          if (!host) return;
          var old = host.querySelector('[data-sg-line]');
          if (old) old.remove();

          var props = item.properties || {};
          var box = document.createElement('div');
          box.className = 'sg-line';
          box.setAttribute('data-sg-line', key);
          box.setAttribute('data-sg-qty', item.quantity);
          box.setAttribute('data-sg-vid', item.variant_id);
          var base = {};
          for (var bk in (item.properties || {})) { if (bk.charAt(0) === '_' || bk === 'Gift wrap') base[bk] = item.properties[bk]; }
          box.setAttribute('data-sg-base', JSON.stringify(base));

          if (item.product_type === CARD_TYPE) {
            var d = (draft && String(draft.vid) === String(item.variant_id)) ? draft : null;
            var val = d ? d.v : props;
            box.innerHTML = '<button type="button" class="sg-line__btn" data-sg-editnote>'
              + (props.Message || props.To || props.From ? 'Edit note' : 'Add a note') + '</button>'
              + '<div class="sg-line__fields" data-sg-fields' + (d ? '' : ' hidden') + '>'
              + '<div class="sg-line__two">'
              + '<input type="text" data-sg-lp="To" placeholder="To" value="' + esc(val.To) + '" autocomplete="off" enterkeyhint="next">'
              + '<input type="text" data-sg-lp="From" placeholder="From" value="' + esc(val.From) + '" autocomplete="off" enterkeyhint="next">'
              + '</div><textarea data-sg-lp="Message" rows="2" placeholder="Your handwritten note">'
              + esc(val.Message) + '</textarea></div>';
            if (d && !refocus) refocus = { box: box, field: d.field };
          } else {
            var on = props['Gift wrap'] === 'Yes';
            box.innerHTML = on
              ? '<p class="sg-line__on">Gift wrapped for free</p><button type="button" class="sg-line__btn" data-sg-wrapline="0">Remove gift wrapping</button>'
              : '<button type="button" class="sg-line__btn" data-sg-wrapline="1">Add free gift wrapping</button>';
          }
          host.appendChild(box);
        });
        if (refocus) {
          var f = refocus.box.querySelector('[data-sg-lp="' + refocus.field + '"]');
          if (f && refocus.box.offsetParent !== null) {
            try { f.focus({ preventScroll: true }); var n = f.value.length; f.setSelectionRange(n, n); } catch (e) {}
          }
        }
      }).catch(function () {});
  }

  /* watch the drawer instead of polling the cart on every page load */
  var obsT;
  function watchDrawer() {
    var target = document.querySelector('.js-ajax-cart-content');
    if (!target || target.__sgObs) return;
    target.__sgObs = true;
    try {
      new MutationObserver(function () {
        clearTimeout(obsT); obsT = setTimeout(enhanceLines, 90);
      }).observe(target, { childList: true });
    } catch (e) {}
    if (target.querySelector('.ajax-cart__cart-item')) enhanceLines();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var edit = e.target.closest('[data-sg-editnote]');
    if (edit) {
      e.preventDefault();
      var f = edit.parentNode.querySelector('[data-sg-fields]');
      if (f) f.hidden = !f.hidden;
      if (f && f.hidden) { flushNote(); draft = null; }
      return;
    }
    var w = e.target.closest('[data-sg-wrapline]');
    if (w) {
      e.preventDefault();
      var wbox = w.closest('[data-sg-line]');
      var wkey = wbox.getAttribute('data-sg-line');
      var wqty = parseInt(wbox.getAttribute('data-sg-qty'), 10) || 1;
      var want = w.getAttribute('data-sg-wrapline') === '1';
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var it = (cart.items || []).filter(function (x) { return x.key === wkey; })[0];
          var p = {};
          if (it && it.properties) { for (var k in it.properties) p[k] = it.properties[k]; }
          if (want) p['Gift wrap'] = 'Yes'; else delete p['Gift wrap'];
          return setLine(wkey, wqty, p);
        }).catch(function () {});
      return;
    }

    var opener = e.target.closest('[data-sg-open]');
    if (opener) {
      e.preventDefault();
      state.stamp = null;
      var st = opener.getAttribute('data-sg-stamp');
      if (st) { try { state.stamp = JSON.parse(st); } catch (err) { state.stamp = null; } }
      state.inDrawer = !!opener.closest('#slideout-ajax-cart');
      setOpen(true, opener);
      window.__sgFromPdp = !!opener.closest('[data-sg-pdp]');
      loadCards().then(render).catch(function () {
        ensureSheet().querySelector('[data-sg-grid]').innerHTML =
          '<p class="sg-sheet__loading">Cards could not load. Please try again.</p>';
      });
      return;
    }
    if (e.target.closest('[data-sg-close]')) { setOpen(false); return; }
    if (e.target.closest('[data-sg-card-off]')) { e.preventDefault(); resetBox(); return; }

    var chip = e.target.closest('[data-sg-chip]');
    if (chip) { state.occ = chip.getAttribute('data-sg-chip'); render(); return; }

    var add = e.target.closest('[data-sg-add]');
    if (add) {
      var v = add.getAttribute('data-sg-add');
      var title = add.getAttribute('data-sg-title') || 'your card';
      setOpen(false);
      if (window.__sgFromPdp && addNow) {
        var nbox = document.querySelector('[data-sg-cardbox]');
        addCardNow(v, nbox ? noteFromBox(nbox) : {});
      } else if (window.__sgFromPdp) {
        pending = { v: v, title: title };
        paintChosen(title);
      } else {
        add.disabled = true;
        var stamp = state.stamp, keep = state.inDrawer, pid = add.getAttribute('data-sg-pid') || '';
        var body = stamp
          ? { items: [{ id: parseInt(v, 10), quantity: 1, properties: stamp }] }
          : { id: parseInt(v, 10), quantity: 1 };
        queued(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
        }).then(function () {
          if (stamp) pub('sofia_bundle_add', { anchor: stamp._bundle_anchor, build: stamp._bundle_build, row: 'CARD',
            variant_id: String(v), product_id: String(pid), surface: stamp._bundle_surface || 'cart', arm: 'cart' });
          return refreshDrawer(keep);
        }, function () { return refreshDrawer(false); })
          .then(function () { add.disabled = false; }, function () { add.disabled = false; });
      }
      return;
    }
  });

  /* ---------- card notes: typed into the drawer, saved when the shopper leaves the note ---------- */
  var lineKey = null, saving = null;
  function saveNote(key, dr) {
    if (!dr) return Promise.resolve();
    var note = {};
    ['To', 'From', 'Message'].forEach(function (k) { var val = String(dr.v[k] || '').trim(); if (val) note[k] = val; });
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        /* the key changes with every save, so fall back to the card line with the same variant */
        var it = items.filter(function (x) { return x.key === key; })[0]
          || items.filter(function (x) { return x.product_type === CARD_TYPE && String(x.variant_id) === String(dr.vid); })[0];
        if (!it) return;
        var p = {}, cur = it.properties || {};
        for (var k in cur) { if (k.charAt(0) === '_' || k === 'Gift wrap') p[k] = cur[k]; }
        for (var n in note) p[n] = note[n];
        return setLine(it.key, it.quantity, p);
      }).catch(function () {});
  }
  function flushNote() {
    if (draft && draft.dirty) {
      draft.dirty = false;
      var dr = draft;
      saving = saveNote(lineKey, dr).then(function () { saving = null; }, function () { saving = null; });
    }
    return saving || Promise.resolve();
  }
  /* Leaving the page with a note half saved: one request that survives the navigation (no cart read first). */
  function quickSave() {
    if (!draft || !draft.dirty) return;
    var box = document.querySelector('[data-sg-line="' + lineKey + '"]');
    if (!box) return;
    var p = {};
    try { p = JSON.parse(box.getAttribute('data-sg-base') || '{}'); } catch (e) { p = {}; }
    ['To', 'From', 'Message'].forEach(function (k) { var val = String(draft.v[k] || '').trim(); if (val) p[k] = val; });
    draft.dirty = false;
    try {
      fetch('/cart/change.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: parseInt(box.getAttribute('data-sg-qty'), 10) || 1, properties: p }) });
    } catch (e) {}
  }
  document.addEventListener('input', function (e) {
    var f = e.target;
    if (!f.getAttribute || f.getAttribute('data-sg-lp') === null) return;
    var box = f.closest('[data-sg-line]');
    if (!box) return;
    var v = {};
    box.querySelectorAll('[data-sg-lp]').forEach(function (x) { v[x.getAttribute('data-sg-lp')] = x.value || ''; });
    draft = { vid: box.getAttribute('data-sg-vid'), field: f.getAttribute('data-sg-lp'), v: v, t: Date.now(), dirty: true };
    lineKey = box.getAttribute('data-sg-line');
  });
  /* leaving the note for something else: save now and stop restoring it. A tapped button on iPhone takes no focus, so a
     blur to nowhere is checked a moment later. */
  document.addEventListener('focusout', function (e) {
    if (!draft || !e.target || !e.target.closest || !e.target.closest('[data-sg-fields]')) return;
    var to = e.relatedTarget;
    if (to) {
      if (!(to.closest && to.closest('[data-sg-fields]'))) { flushNote(); draft = null; }
      return;
    }
    setTimeout(function () {
      var a = document.activeElement;
      if (!(a && a.closest && a.closest('[data-sg-fields]'))) { flushNote(); if (draft && !draft.dirty) draft = null; }
    }, 0);
  });
  /* Checkout (or any cart form submit) waits for a note that is still being saved. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var act = (form.getAttribute('action') || '').replace(/\?.*$/, '');
    if (!(form.closest('#slideout-ajax-cart') || /\/cart\/?$/.test(act))) return;
    if (!(draft && draft.dirty) && !saving) return;
    e.preventDefault(); e.stopPropagation();
    var sub = e.submitter, inDrawer = !!form.closest('#slideout-ajax-cart');
    flushNote().then(function () {
      draft = null;
      /* the save rebuilds the drawer (the theme swaps its HTML when its own read returns), so use whichever form is live */
      var f = form, s = sub;
      if (!f.isConnected) f = (inDrawer && document.querySelector('#slideout-ajax-cart form.js-cart-form')) || document.querySelector('form.js-cart-form');
      if (!f) { location.href = '/checkout'; return; }
      if (s && (!s.isConnected || s.form !== f)) s = s.name ? f.querySelector('[name="' + s.name + '"]') : null;
      if (f.requestSubmit) { try { f.requestSubmit(s || undefined); return; } catch (err) {} }
      if (s) s.click(); else f.submit();
    });
  }, true);
  window.addEventListener('pagehide', quickSave);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') quickSave(); });

  /* Enter in a one-line note field moves on to the next field (it used to submit the form around it). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    var f = e.target;
    if (!f || !f.matches || !f.matches('input[data-sg-p], input[data-sg-lp]')) return;
    e.preventDefault();
    var scope = f.closest('[data-sg-note], [data-sg-fields]') || document;
    var list = Array.prototype.slice.call(scope.querySelectorAll('[data-sg-p], [data-sg-lp]'));
    var next = list[list.indexOf(f) + 1];
    if (next) { try { next.focus(); } catch (err) {} }
  });

  watchDrawer();
  document.addEventListener('DOMContentLoaded', watchDrawer);
})();
